import { getDropdownValueById } from 'views/pages/manage/masters/schoolMaster/schoolInfo/constant';
import { endpoint } from '../../../../common/constant';
import moment from 'moment/moment';
import { maskEmail, maskPhoneNumber } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/paymentLink/utils';
export const logsList=[
{key:'basicDetail', tabName:'Basic Details', endpoint:endpoint.audit.basicInformation},
{key:'locationDetail', tabName:'Location Detail', endpoint:endpoint.audit.locationDetail},
{key:'contactDetail', tabName:'Contact Detail', endpoint:endpoint.audit.contactDetails},
{key:'featureSetup', tabName:'Feature Setup', endpoint:endpoint.audit.featureSetup},
{key:'receiptDetail', tabName:'Receipt Detail', endpoint:endpoint.manageReceipts.audit},
{key:'paymentGateway', tabName:'Payment Gateway', endpoint:endpoint.audit.paymentGateway},
{key:'taxMapping', tabName:'Tax Mapping', endpoint:endpoint.audit.taxMapping},
{key:'cscMapping', tabName:'CSC Mapping', endpoint:endpoint.audit.cscMapping},
]
export const concatenateObjectValues = (obj) => {
  const excludedKeys = new Set([
    'id','businessAreaKey','businessAreaId','businessUnitId','websiteId','salesforceId',
    'businessAreaDesc','createdBy','updatedBy','createdOn','updatedOn','isDeleted',
    'rev','revType','cscDeleted','cscUpdatedOn'
  ]);

  const getValue = (value) => {
    if (Array.isArray(value)) {
      return value
        .map(item => (typeof item === 'object' ? item?.label ?? '' : item))
        .filter(Boolean)
        .join(', ');
    }

    if (typeof value === 'object' && value !== null) {
      return value?.label ?? '';
    }

    return value;
  };

  return Object.entries(obj)
    .filter(([key]) => !excludedKeys.has(key))
    .map(([key, value]) => {
      let formattedValue =
        key === 'effectiveDate'
          ? moment(value).format('DD/MM/YYYY')
          : getValue(value);

      if (!formattedValue) return '';

      // Masking logic
      if (/email/i.test(key)) {
        formattedValue = maskEmail(formattedValue);
      } else if (/(phone|mobile|number)/i.test(key)) {
        formattedValue = maskPhoneNumber(formattedValue);
      }

      return formattedValue;
    })
    .filter(Boolean)
    .join(' ');
};
